import { NgModule }           from '@angular/core';

import { VerificationComponent } from '../verification/verification.component';
import { PollingPlaceComponent } from './pollingplace/pollingplace.component';
import { RegistrationComponent } from './registration/registration.component';
import { VotingDistrictComponent } from './votingdistrict/votingdistrict.component';
import { ElectedOfficialsComponent } from './electedofficials/electedofficials.component';
import { CandidatesComponent } from './candidates/candidates.component';
import { BallotsComponent } from './ballots/ballots.component';
import { FAQComponent } from './faq/faq.component';
import { EarlyVotingComponent } from './earlyvoting/earlyvoting.component';

// import child feature modules
import { LocationSearchModule }  from '../location-search/locationsearch.module';
import { MapInfoModule }  from './map/mapinfo.module';

//import the shared functionality module
import { SharedModule }   from '../shared/shared.module';

@NgModule({
  imports:      [
        LocationSearchModule, 
        MapInfoModule, 
        SharedModule],
  declarations: [ 
        VerificationComponent,
        PollingPlaceComponent,
        RegistrationComponent, 
        VotingDistrictComponent, 
        ElectedOfficialsComponent, 
        CandidatesComponent, 
        BallotsComponent, 
        FAQComponent,
        EarlyVotingComponent ],
  providers:    [ ],
  exports: [ VerificationComponent,
        PollingPlaceComponent,
        RegistrationComponent, 
        VotingDistrictComponent, 
        ElectedOfficialsComponent, 
        CandidatesComponent, 
        BallotsComponent, 
        FAQComponent,
        EarlyVotingComponent,
        MapInfoModule  ]
})
export class VoterInformationModule { }


// WEBPACK FOOTER //
// ./app/information/voterinformation.module.ts